// src/components/popups/PiAuthOnlyDrawer.js

import React from 'react';
import './PiAuthOnlyDrawer.css';

const PI_REFERRAL_LINK = "https://minepi.com/SizweMondlane";

const PiAuthOnlyDrawer = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleCreateAccount = () => {
    window.open(PI_REFERRAL_LINK, "_blank");
  };

  return (
    <div className="pi-auth-only-drawer">
      <div className="pi-auth-only-backdrop" onClick={onClose} />

      <div className="pi-auth-only-content">
        <h3>Pi Auth Required</h3>

        <p>
          Currently, BarterFi only supports login using your Pi Browser account.
          This ensures you get the full benefit of Pi Network’s secure ecosystem,
          including tipping, escrow, and Pi transactions.
        </p>

        <p>
          Please use the <strong>“Continue with Pi Account”</strong> option to access your account.
        </p>

        <p className="pi-auth-extra">
          New to Pi Network? Create a free account to start using Pi-powered apps like BarterFi.
        </p>

        <button
          className="pi-create-account-btn"
          onClick={handleCreateAccount}
        >
          Create Pi Account
        </button>

        <button
          className="pi-auth-close-btn"
          onClick={onClose}
        >
          Got it
        </button>

      </div>
    </div>
  );
};

export default PiAuthOnlyDrawer;
